import { parseAsInteger, parseAsString } from '@repo/sdk/qs/parsers'

/**
 * The tab shown when the URL carries no `status`. nuqs' `withDefault` resolves
 * it in memory without ever writing `?status=active`, so the fetch params —
 * which read the raw URL — have to apply the same default or they request every
 * status unfiltered, leaking cancelled and archived loads into Active.
 */
export const DEFAULT_LOADS_TAB = 'active'

/** Loads per page when the URL carries no `perPage`; denser rows fill the screen at 50. */
export const LOADS_PAGE_SIZE = 50

export const loadsPerPageParser = parseAsInteger.withDefault(LOADS_PAGE_SIZE)
export const loadsStatusParser = parseAsString.withDefault(DEFAULT_LOADS_TAB)
